import React from 'react';
import './_commonjsHelpers-df867233.js';
import { P as PropTypes } from './index-6a8f8095.js';
import styled, { css } from 'styled-components';
import { _ as _taggedTemplateLiteral, a as _objectWithoutProperties, b as _extends } from './_rollupPluginBabelHelpers-b3c9b1cd.js';
import './_baseEach-3b97c1a8.js';
import './isArray-a3f14da2.js';
import './_Map-9acd9da3.js';
import './get-f58f8821.js';
import './_baseIteratee-651c88ed.js';
import './index-7f6959fc.js';
import './index-ae4b14fb.js';
import './head-b3f271d9.js';
import './map-651e82c0.js';
import './join-15b17329.js';
import { _ as _noop } from './noop-d79f8d84.js';
import './isEmpty-9e4c9724.js';
import './wrapMediaQuery-d94fbf55.js';
import { Text } from './Typographies.js';
import './index-f96168ba.js';

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  display: inline-block;\n  text-align: ", ";\n  cursor: pointer;\n\n  &:hover {\n    opacity: ", ";\n  }\n  &:disabled {\n    &:hover {\n      opacity: 1;\n      cursor: not-allowed;\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}
var border = css(["border:", ";border-radius:", ";&:disabled{border:", ";}"], function (_ref) {
  var variant = _ref.variant,
      theme = _ref.theme;
  return "".concat(theme.components.button.borders[variant].borderWidth, " solid ").concat(theme.components.button.colors[variant].border);
}, function (_ref2) {
  var variant = _ref2.variant,
      theme = _ref2.theme;
  return theme.components.button.borders[variant].borderRadius;
}, function (_ref3) {
  var variant = _ref3.variant,
      theme = _ref3.theme;
  return "".concat(theme.components.button.borders[variant].borderWidth, " solid ").concat(theme.components.button.colors.disabled.border);
});
var colors = css(["background-color:", ";color:", ";&:disabled{background-color:", ";color:", ";}"], function (_ref4) {
  var variant = _ref4.variant,
      theme = _ref4.theme;
  return theme.components.button.colors[variant].background;
}, function (_ref5) {
  var variant = _ref5.variant,
      theme = _ref5.theme;
  return theme.components.button.colors[variant].text;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.components.button.colors.disabled.background;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.components.button.colors.disabled.text;
});
var forms = css(["height:", ";"], function (_ref8) {
  var theme = _ref8.theme;
  return theme.components.button.sizes.height;
});
var spaces = css(["padding:", " ", ";"], function (_ref9) {
  var theme = _ref9.theme;
  return theme.components.button.spaces.paddingHeight;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.components.button.spaces.paddingWidth;
});
var StyledButton = styled(Text.withComponent('button'))(_templateObject(), border, colors, forms, spaces, function (_ref11) {
  var theme = _ref11.theme;
  return theme.components.button.textAlign;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.components.button.opacities.hover;
});
StyledButton.defaultProps = {
  variant: 'normal'
};

function _templateObject$1() {
  var data = _taggedTemplateLiteral([""]);

  _templateObject$1 = function _templateObject() {
    return data;
  };

  return data;
}
/**
 * A Simple Button.
 */

var Button = function Button(_ref) {
  var children = _ref.children,
      disabled = _ref.disabled,
      onClick = _ref.onClick,
      type = _ref.type,
      variant = _ref.variant,
      rest = _objectWithoutProperties(_ref, ["children", "disabled", "onClick", "type", "variant"]);

  return React.createElement(StyledButton, _extends({
    disabled: disabled,
    type: type,
    onClick: onClick,
    variant: variant
  }, rest), children);
};

Button.defaultProps = {
  children: '',
  disabled: false,
  onClick: _noop(),
  type: 'button',
  variant: 'primary'
};
Button.propTypes = {
  /**
   * Content of the component. Only text for now.
   */
  children: PropTypes.string,

  /**
   * Is the Button disabled or not.
   */
  disabled: PropTypes.bool,

  /**
   * This function is called when the user clicks on the Button.
   */
  onClick: PropTypes.func,

  /**
   * The type to pass to the underlying button html element
   */
  type: PropTypes.string,

  /**
   * The type of variation to display
   */
  variant: PropTypes.oneOf(['primary', 'neutral', 'light', 'dark'])
};
/** @component */

var Button$1 = styled(Button)(_templateObject$1());

export default Button$1;
